/* eslint-disable react/prop-types */
import { FormattedMessage } from 'react-intl';
import commonTranslations from 'shared/translations/overlay-common-translations';
import { isPreviewEnabled } from 'shared/ui-selectors/video/preview';


/**
 * Is open video without preview button visible
 * @param props {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
export function isVisible({ video }) {
  return !isPreviewEnabled(video);
}

/**
 * Open video without preview button text
 * @param props {Object}
 * @param props.video {Object}
 * @param props.translation {Object} default commonTranslations.startWatching
 * @return {React.Component}
 */
export default function renderOpenVideoWithoutPreviewButtonText(props) {
  if (!isVisible(props)) {
    return null;
  }
  const translation = props.translation || commonTranslations.startWatching;
  return <FormattedMessage {...translation} />;
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/channel/open-video-without-preview-button-text.js